export enum CustodianProfileOnboardingRoutesEnum {
  Assets = 'assets',
  Operations = 'operations',
  Summary = 'summary',
}
